import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Card = styled.div`
  width: 69px;
  height: 78px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

export const CardImageContainer = styled.div`
  display: flex;
  border-radius: 12.5px;
  border: 2px solid transparent;
  cursor: pointer;
  background: radial-gradient(
    81.52% 81.52% at 67.33% 85.84%,
    red 0%,
    blue 100%
  );
`;

export const CardImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 12.5px;
`;

export const CardText = styled.h1`
  font-family: Inter-Regular;
  font-weight: 500; 
  font-size: 10px;
  color: #1B1B1B;
`;
